import UserPermissionsForm from './UserPermissionsForm';

export default UserPermissionsForm;
